/* PupPilot(TM) Shopify theme - storefront interactions (vanilla JS, no deps) */
(function () {
  'use strict';

  /* ---------- gallery ---------- */
  var mainImg = document.getElementById('galleryMain');
  var thumbs = document.querySelectorAll('#galleryThumbs .thumb');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (mainImg) mainImg.setAttribute('src', btn.querySelector('img').getAttribute('src'));
    });
  });

  /* ---------- testimonial carousel dots ---------- */
  var qTrack = document.getElementById('quotesTrack');
  var qDots = document.getElementById('quotesDots');
  if (qTrack && qDots) {
    var slides = qTrack.children.length;
    for (var i = 0; i < slides; i++) {
      var d = document.createElement('button');
      if (i === 0) d.classList.add('is-active');
      (function (idx) {
        d.addEventListener('click', function () {
          qTrack.scrollTo({ left: qTrack.clientWidth * idx, behavior: 'smooth' });
        });
      })(i);
      qDots.appendChild(d);
    }
    qTrack.addEventListener('scroll', function () {
      var idx = Math.round(qTrack.scrollLeft / qTrack.clientWidth);
      qDots.querySelectorAll('button').forEach(function (b, bi) {
        b.classList.toggle('is-active', bi === idx);
      });
    });
  }

  /* ---------- before/after slider ---------- */
  var baWrap = document.getElementById('baWrap');
  var baBefore = document.getElementById('baBefore');
  var baHandle = document.getElementById('baHandle');
  if (baWrap && baBefore && baHandle) {
    var dragging = false;
    var baImg = baBefore.querySelector('img');
    function syncWidth() { if (baImg) baImg.style.width = baWrap.clientWidth + 'px'; }
    syncWidth();
    window.addEventListener('resize', syncWidth);
    if (baImg && !baImg.complete) baImg.addEventListener('load', syncWidth);
    function setPos(clientX) {
      var rect = baWrap.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(4, Math.min(96, pct));
      baBefore.style.width = pct + '%';
      baHandle.style.left = pct + '%';
    }
    function start() { dragging = true; }
    function stop() { dragging = false; }
    function move(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(x);
    }
    baHandle.addEventListener('mousedown', start);
    baHandle.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mouseup', stop);
    window.addEventListener('touchend', stop);
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    baWrap.addEventListener('click', function (e) { setPos(e.clientX); });
  }

  /* ---------- sticky add-to-cart show/hide ---------- */
  var sticky = document.getElementById('sticky');
  var bundle = document.querySelector('.bundle');
  if (sticky && bundle && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(bundle);
  }

  /* ---------- REAL Add to Cart -> Shopify checkout ----------
     Adds the seat plus both free gifts in one shot. Uses /cart/update.js,
     which sets ABSOLUTE quantities, so repeat clicks can never stack the
     cart to qty 2, 3, 4 and the gifts can never be duplicated.          */
  var atcData = document.getElementById('atcData');
  var variantId = atcData ? atcData.getAttribute('data-variant-id') : null;
  var giftRaw = atcData ? (atcData.getAttribute('data-gift-ids') || '') : '';
  var giftIds = giftRaw.split(',').filter(function (v) { return v && v !== '0'; });
  var atcBusy = false;

  // Add ?cartdebug=1 to any product URL to see exactly what the theme found.
  var debugOn = window.location.search.indexOf('cartdebug') > -1;

  function showCartDebug(report) {
    var box = document.createElement('div');
    box.setAttribute('style', 'position:fixed;left:8px;bottom:8px;z-index:9999;max-width:340px;' +
      'background:#2E211C;color:#fff;font:11px/1.5 monospace;padding:12px 14px;border-radius:10px;white-space:pre-wrap');
    box.textContent =
      'CART DEBUG\n' +
      'This page: ' + (atcData ? atcData.getAttribute('data-product-title') : '?') + '\n' +
      'Main variant: ' + variantId + '\n' +
      'Gifts found: ' + (atcData ? atcData.getAttribute('data-gift-debug') : '?') + '\n' +
      'Gift ids: ' + (giftIds.length ? giftIds.join(', ') : 'NONE') + '\n' +
      '$0 products in store: ' + (atcData ? atcData.getAttribute('data-free-scan') : '?') + '\n\n' +
      report.join('\n') + '\n\n(tap to dismiss)';
    box.addEventListener('click', function () { box.remove(); });
    document.body.appendChild(box);
  }

  if (debugOn && atcData) {
    console.log('[PupPilot] page product:', atcData.getAttribute('data-product-title'));
    console.log('[PupPilot] main variant:', variantId);
    console.log('[PupPilot] gifts found:', atcData.getAttribute('data-gift-debug'));
    console.log('[PupPilot] gift variant ids:', giftIds);
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart request failed');
      return r.json();
    });
  }

  var atcButtons = document.querySelectorAll('[data-add]');
  atcButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (atcBusy) return;                       // kills double-fire / double-tap
      if (!variantId || variantId === '0') {
        console.error('[PupPilot] No variant id on this page, so nothing can be added. ' +
                      'Check that atc-data receives the product object.');
        showCartDebug(['ABORTED  no variant id for this page']);
        return;
      }

      atcBusy = true;
      var labels = [];
      atcButtons.forEach(function (b) { labels.push(b.textContent); b.disabled = true; });
      btn.textContent = 'ADDING...';

      var restore = function () {
        atcBusy = false;
        atcButtons.forEach(function (b, i) { b.disabled = false; b.textContent = labels[i]; });
      };

      // One request per item. /cart/update.js is atomic, so a single bad gift
      // variant used to abort the whole call and the seat never got added.
      // Now each item is independent and a failing gift is simply skipped.
      var queue = [{ id: variantId, role: 'product' }];
      giftIds.forEach(function (gid) { queue.push({ id: gid, role: 'gift' }); });

      var report = [];
      var chain = Promise.resolve();
      queue.forEach(function (entry) {
        chain = chain.then(function () {
          var updates = {};
          updates[entry.id] = 1;
          return postJSON('/cart/update.js', { updates: updates })
            .then(function () { report.push('OK    ' + entry.role + ' ' + entry.id); })
            .catch(function () { report.push('FAILED  ' + entry.role + ' ' + entry.id); });
        });
      });

      chain
        .then(function () {
          if (debugOn) showCartDebug(report);
          return refreshDrawer(true);
        })
        .then(restore)
        .catch(function () { restore(); window.location.href = '/cart'; });
    });
  });

  /* ---------- Slide-in cart drawer ---------- */
  var drawer = document.getElementById('cartDrawer');

  function openDrawer() {
    if (!drawer) { window.location.href = '/cart'; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  // Pulls fresh cart HTML from Shopify so the drawer always shows what is
  // really in the cart: the seat plus both free gifts.
  function refreshDrawer(open) {
    if (!drawer) { window.location.href = '/cart'; return Promise.resolve(); }
    return fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cartDrawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;

        var counter = drawer.querySelector('[data-cart-count]');
        var count = counter ? counter.getAttribute('data-cart-count') : null;
        if (count !== null) {
          document.querySelectorAll('#cartCount').forEach(function (el) { el.textContent = count; });
        }
        if (open) openDrawer();
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (t === drawer || t.closest('.cdrawer__ov')) { closeDrawer(); return; }

    // Header cart icon opens the drawer instead of navigating away
    var cartIcon = t.closest('.header__cart');
    if (cartIcon && drawer) { e.preventDefault(); openDrawer(); return; }

    // Quantity steppers and remove buttons inside the drawer stay in the drawer
    var change = t.closest('[data-cart-change]');
    if (change && change.closest('#cartDrawer')) {
      e.preventDefault();
      if (change.classList.contains('is-off')) return;
      postJSON('/cart/change.js', {
        line: parseInt(change.getAttribute('data-line'), 10),
        quantity: parseInt(change.getAttribute('data-qty'), 10)
      }).then(function () { return refreshDrawer(false); })
        .catch(function () { window.location.href = '/cart'; });
    }
  });

  /* ---------- Hamburger menu drawer ---------- */
  var nav = document.getElementById('navDrawer');

  function openNav() {
    if (!nav) return;
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-open');
  }

  function closeNav() {
    if (!nav) return;
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-open');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__menu')) { e.preventDefault(); openNav(); return; }
    if (e.target.closest('[data-nav-close]') || e.target.closest('.ndrawer__ov')) { closeNav(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeNav(); }
  });

  // A cart holding nothing but free gifts is an orphan left over from a
  // removed product. Clear it so nobody sees a $0.00 gift-only cart.
  if (drawer) {
    var snapshot = drawer.querySelector('[data-cart-count]');
    if (snapshot &&
        parseInt(snapshot.getAttribute('data-cart-count'), 10) > 0 &&
        parseInt(snapshot.getAttribute('data-cart-total'), 10) === 0) {
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () { return refreshDrawer(false); })
        .catch(function () {});
    }
  }

  /* ---------- Cart reservation countdown ----------
     Looks the element up every tick so it survives drawer re-renders. */
  var END_KEY = 'pp_cart_timer_end';
  var end = parseInt(sessionStorage.getItem(END_KEY) || '0', 10);
  if (!end || end < Date.now()) {
    end = Date.now() + 5 * 60 * 1000;
    sessionStorage.setItem(END_KEY, String(end));
  }
  setInterval(function () {
    var el = document.getElementById('cartTimer');
    if (!el) return;
    var left = Math.floor((end - Date.now()) / 1000);
    if (left <= 0) {                    // restart rather than sit frozen on 0:00
      end = Date.now() + 5 * 60 * 1000;
      sessionStorage.setItem(END_KEY, String(end));
      left = 5 * 60;
    }
    var m = Math.floor(left / 60), s = left % 60;
    el.textContent = m + ':' + (s < 10 ? '0' + s : s);
  }, 1000);
})();
